let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kn4Lg")).then(() => parcelRequire('d6iMp'));